/* eslint-disable no-useless-escape */
export const capitalizeFirstLetter = (string: any) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export default capitalizeFirstLetter
